export interface MultiSelectTag {
  name: string;
  value: string;
  type: string;
}

export const ACCOUNT = 'account';
export const OPPORTUNITY = 'opportunity';
export const BOTH = 'both';

function convertToOpportunityMultiSelectTag(tag: MultiSelectTag): MultiSelectTag {
  tag.value = tag.name;
  tag.type = OPPORTUNITY;
  return tag;
}

function getUniqueTags(tags: MultiSelectTag[]): MultiSelectTag[] {
  const object: any = {};
  tags.forEach((tag) => {
    if (!tag.value) {
      tag = convertToOpportunityMultiSelectTag(tag);
    }
    const existingTag = object[tag.value];
    if (existingTag && existingTag.name !== tag.name) {
      console.log(
        'Multiple tags with same value but different name. Using name:',
        existingTag.name,
        'tags:',
        existingTag,
        tag,
      );
      return;
    }
    if (existingTag && existingTag.type !== tag.type) {
      tag.type = BOTH;
    }
    object[tag.value] = tag;
  });
  return Object.keys(object).map((key) => object[key]);
}

export function sortTagOptions(tags: MultiSelectTag[]): MultiSelectTag[] {
  const values = getUniqueTags(tags);
  return values.sort(function (a, b): number {
    if (a.name.toLowerCase() < b.name.toLowerCase()) {
      return -1;
    }
    if (a.name.toLowerCase() > b.name.toLowerCase()) {
      return 1;
    }
    return 0;
  });
}
